$(document).on('turbo:load', function() {
  $('.unfilter-subjects, .filter-subjects').on('click', function() {
    $('.unfiltered-subjects, .filtered-subjects').toggleClass('is-hidden');
  });
});
